<div style="display: flex; height: 100%">
  <iframe style="width: 100%; height: 100%; border: none; overflow: hidden" [src]="animalUrl" id="externalAppFrame"> </iframe>
</div>
